import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SessionStorageService {
    private readonly storageKey = 'sessionData';
    private readonly expirationKey = 'sessionExpiration';

    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    storeData(data: any): void {
        const expirationTime = Date.now() + 10 * 60 * 1000;
        sessionStorage.setItem(this.storageKey, JSON.stringify(data));
        sessionStorage.setItem(this.expirationKey, expirationTime.toString());
    }

    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    getData(): any {
        const expirationTime = sessionStorage.getItem(this.expirationKey);

        if (!expirationTime) {
            return null;
        }

        const currentTime = Date.now();

        if (currentTime > parseInt(expirationTime)) {
            this.clearData();
            return null;
        }

        const data = sessionStorage.getItem(this.storageKey);
        return data ? JSON.parse(data) : null;
    }

    clearData(): void {
        sessionStorage.removeItem(this.storageKey);
        sessionStorage.removeItem(this.expirationKey);
    }

    isExpired(): boolean {
        const expirationTime = sessionStorage.getItem(this.expirationKey);
        if (!expirationTime) {
            return true;
        }

        const currentTime = Date.now();
        return currentTime > parseInt(expirationTime);
    }
}
